<template>
  <div>
    <app-loader v-show="$store.state.appConfig.showLoader" />
    <div
      v-if="showMessage"
      class="mobileWrapper floatCss"
    >
      <div class="floatCss">
        <b-row>
          <b-col cols="12">
            <div class="purchaser-request floatCss">
              <h3>{{ titleText }} request</h3>
              <div class="purchaser-request-list floatCss">
                <span class="pr-list-item-left">Transferor</span>
                <span class="pr-list-item-right">{{ transferRequest.originalPurchaser ? transferRequest.originalPurchaser.name : '' }}</span>
              </div>
              <div class="purchaser-request-list floatCss">
                <span class="pr-list-item-left">Transfer fee</span>
                <span class="pr-list-item-right">{{ transferRequest.transferFee ? `$${numberFormat(transferRequest.transferFee)} (Inc. GST)` : '-' }}</span>
              </div>
              <div class="notePR floatCss">
                <strong>Note:</strong> Transfer fee is payable during approval. Our staff will assist with payment.
              </div>
            </div>
          </b-col>
        </b-row>
      </div>
      <div class="purchaserDetails floatCss">
        <b-row>
          <b-col cols="12">
            <div class="fileDetails floatCss">
              <b-button
                v-b-toggle.collapse-1
                variant="primary"
              >
                <span v-if="transferRequest.relatedFiles && transferRequest.relatedFiles.length">
                  Main file details
                </span>
                <span v-else>
                  File details
                </span>
              </b-button>
              <b-collapse
                id="collapse-1"
                visible
                class="cm-gap-1 floatCss"
              >
                <div class="card-text">
                  <div class="fd-wrapper floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">File no.</span>
                      <span class="pr-list-item-right">{{ transferRequest.fileNo }}</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Product</span>
                      <span class="pr-list-item-right">{{ transferRequest.nvsFileType }}</span>
                    </div>
                    <template v-if="transferRequest.nvsFileType == 'Funeral Service Package'">
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Package name</span>
                        <span class="pr-list-item-right">{{ packageName }}</span>
                      </div>
                    </template>
                    <template v-else-if="['Niche', 'Pedestal', 'Little Buddha'].includes(transferRequest.nvsFileType)">
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Lot no.</span>
                        <span class="pr-list-item-right">{{ transferRequest.lotLocation }}</span>
                      </div>
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Lot type</span>
                        <span class="pr-list-item-right">{{ transferRequest.lotType }}</span>
                      </div>
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Earliest interment date</span>
                        <span class="pr-list-item-right">{{ lotDetail.intermentDate ? dateFormat(lotDetail.intermentDate) : 'Immediate' }}</span>
                      </div>
                    </template>
                  </div>
                  <!-- <div
                    v-if="transferRequest.transferType == 'purchaser'"
                    class="fd-wrapper floatCss"
                  >
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Purchase option</span>
                      <span class="pr-list-item-right">Pay downpayment</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Order total</span>
                      <span class="pr-list-item-right">{{ getOrderTotal(fileDetail) }}</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Downpayment</span>
                      <span class="pr-list-item-right">$8,349.40 (≈20%)</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Payments made</span>
                      <span class="pr-list-item-right">${{ numberFormat(fileDetail.ledgerSummary ? fileDetail.ledgerSummary.totalPayment : 0) }}</span>
                    </div>
                  </div> -->
                  <div
                    v-if="transferRequest.transferType == 'purchaser'"
                    class="rm-balance floatCss"
                  >
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Remaining balance</span>
                      <span class="pr-list-item-right">${{ numberFormat(fileDetail.ledgerSummary ? fileDetail.ledgerSummary.outstanding : 0) }}</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Installment(s) remaining</span>
                      <span class="pr-list-item-right">{{ fileDetail.installmentSummary ? fileDetail.installmentSummary.remainingTenure : 0 }} of {{ fileDetail.installmentSummary ? fileDetail.installmentSummary.tenure : 0 }} months</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Monthly installment</span>
                      <span class="pr-list-item-right">${{ numberFormat(fileDetail.installmentSummary ? fileDetail.installmentSummary.monthlyAmount : 0) }}</span>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="transferRequest.transferType == 'purchaser'">
          <b-col cols="12">
            <div class="pr-toggle-section floatCss">
              <b-button
                v-b-toggle.collapse-2
                variant="primary"
              >
                Price breakdown
              </b-button>
              <b-collapse
                id="collapse-2"
                class="cm-gap-1 floatCss"
              >
                <div class="card-text">
                  <div class="pb-list-block floatCss">
                    <div
                      v-for="(item, key) in getBillingItems(fileDetail)"
                      :key="key"
                      class="purchaser-request-list floatCss"
                    >
                      <span class="pr-list-item-left">{{ item.item }}</span>
                      <span class="pr-list-item-right">${{ numberFormat(item.amount) }}</span>
                    </div>
                    <div
                      v-if="getDiscountTotal(fileDetail) > 0"
                      class="purchaser-request-list floatCss"
                    >
                      <span class="pr-list-item-left">Discounts</span>
                      <span class="pr-list-item-right">-${{ numberFormat(getDiscountTotal(fileDetail)) }}</span>
                    </div>
                  </div>
                  <div class="pb-list-block floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Subtotal</span>
                      <span class="pr-list-item-right">${{ numberFormat(getSubtotal(fileDetail)) }}</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">GST {{ getGstPercent(fileDetail) }}%</span>
                      <span class="pr-list-item-right">${{ numberFormat(getGstAmount(fileDetail)) }}</span>
                    </div>
                  </div>
                  <div class="pb-list-block floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Order total</span>
                      <span class="pr-list-item-right"><strong>${{ numberFormat(getCalculatedOrderTotal(fileDetail)) }}</strong></span>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="transferRequest.transferType == 'ownership' && transferRequest.nvsFileType == 'Funeral Service Package'">
          <b-col cols="12">
            <div class="pr-toggle-section floatCss">
              <b-button
                v-b-toggle.collapse-2
                variant="primary"
              >
                Current product value
              </b-button>
              <b-collapse
                id="collapse-2"
                class="cm-gap-1 floatCss"
              >
                <div class="card-text">
                  <div class="pb-list-block floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Product price</span>
                      <span class="pr-list-item-right">$12,800.00</span>
                    </div>
                  </div>
                  <div class="pb-list-block floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Subtotal</span>
                      <span class="pr-list-item-right">$12,800.00</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">GST 9%</span>
                      <span class="pr-list-item-right">$1,152.00</span>
                    </div>
                  </div>
                  <div class="pb-list-block floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Total value</span>
                      <span class="pr-list-item-right"><strong>$13,952.00</strong></span>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-col>
        </b-row>
        <b-row v-if="transferRequest.transferType == 'ownership' && ['Niche', 'Pedestal', 'Little Buddha'].includes(transferRequest.nvsFileType)">
          <b-col cols="12">
            <div class="pr-toggle-section floatCss">
              <b-button
                v-b-toggle.collapse-2
                variant="primary"
              >
                Current lot value
              </b-button>
              <b-collapse
                id="collapse-2"
                class="cm-gap-1 floatCss"
              >
                <div class="card-text">
                  <div class="pb-list-block floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Lot price</span>
                      <span class="pr-list-item-right">${{ numberFormat(getLotPrice()) }}</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Maintenance fee</span>
                      <span class="pr-list-item-right">${{ numberFormat(getMaintenanceFee()) }}</span>
                    </div>
                  </div>
                  <div class="pb-list-block floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Subtotal</span>
                      <span class="pr-list-item-right">${{ numberFormat(getLotPrice() + getMaintenanceFee()) }}</span>
                    </div>
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">GST {{ gstPercentage }}%</span>
                      <span class="pr-list-item-right">${{ numberFormat(getLotGstAmount()) }}</span>
                    </div>
                  </div>
                  <div class="pb-list-block floatCss">
                    <div class="purchaser-request-list floatCss">
                      <span class="pr-list-item-left">Total Value</span>
                      <span class="pr-list-item-right"><strong>${{ numberFormat(getLotTotalValue()) }}</strong></span>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-col>
        </b-row>
        <b-row>
          <b-col cols="12">
            <div class="pr-toggle-section no-border-bottom floatCss">
              <b-button
                v-b-toggle.collapse-3
                variant="primary"
              >
                Service agent details
              </b-button>
              <b-collapse
                id="collapse-3"
                visible
                class="cm-gap-1 floatCss"
              >
                <div class="card-text">
                  <div class="agentBlock floatCss">
                    <div class="agentPhoto">
                      <img :src="mainAgent.image || defaultUserAvatar">
                    </div>
                    <div class="agentInfo">
                      <div class="agentInfoInner floatCss">
                        <h3>{{ mainAgent.name }}</h3>
                        <p>Agent code: {{ mainAgent.code }}</p>
                      </div>
                    </div>
                  </div>
                </div>
              </b-collapse>
            </div>
          </b-col>
        </b-row>
      </div>
      <template v-if="transferRequest.relatedFiles && transferRequest.relatedFiles.length">
        <div
          v-for="file in transferRequest.relatedFiles"
          :key="file._id"
          class="purchaserDetails relatedfile-block floatCss"
        >
          <b-row>
            <b-col cols="12">
              <div class="fileDetails floatCss">
                <b-button
                  v-b-toggle.collapse-4
                  variant="primary"
                >
                  Related file details
                </b-button>
                <b-collapse
                  id="collapse-4"
                  visible
                  class="cm-gap-1 floatCss"
                >
                  <div class="card-text">
                    <div class="fd-wrapper floatCss">
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">File no.</span>
                        <span class="pr-list-item-right">{{ file.fileNo }}</span>
                      </div>
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Product</span>
                        <span class="pr-list-item-right">{{ file.nvsFileType }}</span>
                      </div>
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Item</span>
                        <span class="pr-list-item-right">{{ getRelatedFileItems(file) }}</span>
                      </div>
                      <!-- <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Purchase option</span>
                        <span class="pr-list-item-right">Pay in full</span>
                      </div> -->
                      <!-- <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Order total</span>
                        <span class="pr-list-item-right">{{ getOrderTotal(file) }}</span>
                      </div>
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Payments made</span>
                        <span class="pr-list-item-right">${{ numberFormat(file.ledgerSummary ? file.ledgerSummary.totalPayment : 0) }}</span>
                      </div> -->
                    </div>
                    <div
                      v-if="transferRequest.transferType == 'purchaser'"
                      class="rm-balance floatCss"
                    >
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Remaining balance</span>
                        <span class="pr-list-item-right">${{ numberFormat(file.ledgerSummary ? file.ledgerSummary.outstanding : 0) }}</span>
                      </div>
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Installment(s) remaining</span>
                        <span class="pr-list-item-right">{{ file.installmentSummary ? file.installmentSummary.remainingTenure : 0 }} of {{ file.installmentSummary ? file.installmentSummary.tenure : 0 }} months</span>
                      </div>
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Monthly installment</span>
                        <span class="pr-list-item-right">${{ numberFormat(file.installmentSummary ? file.installmentSummary.monthlyAmount : 0) }}</span>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pr-toggle-section floatCss">
                <b-button
                  v-b-toggle.collapse-5
                  variant="primary"
                >
                  Price breakdown
                </b-button>
                <b-collapse
                  id="collapse-5"
                  class="cm-gap-1 floatCss"
                >
                  <div class="card-text">
                    <div class="pb-list-block floatCss">
                      <!-- <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Product(s) price</span>
                        <span class="pr-list-item-right">$488.00</span>
                      </div> -->
                      <div
                        v-for="(item, key) in getBillingItems(file)"
                        :key="key"
                        class="purchaser-request-list floatCss"
                      >
                        <span class="pr-list-item-left">{{ item.item }}</span>
                        <span class="pr-list-item-right">${{ numberFormat(item.amount) }}</span>
                      </div>
                      <div
                        v-if="getDiscountTotal(file) > 0"
                        class="purchaser-request-list floatCss"
                      >
                        <span class="pr-list-item-left">Discounts</span>
                        <span class="pr-list-item-right">-${{ numberFormat(getDiscountTotal(file)) }}</span>
                      </div>
                    </div>
                    <div class="pb-list-block floatCss">
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Subtotal</span>
                        <span class="pr-list-item-right">${{ numberFormat(getSubtotal(file)) }}</span>
                      </div>
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">GST {{ getGstPercent(file) }}%</span>
                        <span class="pr-list-item-right">${{ numberFormat(getGstAmount(file)) }}</span>
                      </div>
                    </div>
                    <div class="pb-list-block floatCss">
                      <div class="purchaser-request-list floatCss">
                        <span class="pr-list-item-left">Order total</span>
                        <span class="pr-list-item-right"><strong>${{ numberFormat(getCalculatedOrderTotal(file)) }}</strong></span>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </b-col>
          </b-row>
          <b-row>
            <b-col cols="12">
              <div class="pr-toggle-section no-border-bottom floatCss">
                <b-button
                  v-b-toggle.collapse-6
                  variant="primary"
                >
                  Service agent details
                </b-button>
                <b-collapse
                  id="collapse-6"
                  visible
                  class="cm-gap-1 floatCss"
                >
                  <div class="card-text">
                    <div class="agentBlock floatCss">
                      <div class="agentPhoto">
                        <img :src="getAgentData(file.agents, 'image')">
                      </div>
                      <div class="agentInfo">
                        <div class="agentInfoInner floatCss">
                          <h3>{{ getAgentData(file.agents, 'name') }}</h3>
                          <p>Agent code: {{ getAgentData(file.agents, 'code') }}</p>
                        </div>
                      </div>
                    </div>
                  </div>
                </b-collapse>
              </div>
            </b-col>
          </b-row>
        </div>
      </template>
      <div class="purchaserButtonGroup floatCss">
        <b-button
          v-b-modal.modal-center1
          href="#"
          class="withdraw-btn"
        >
          Withdraw
        </b-button>
        <b-modal
          id="modal-center1"
          centered
          dialog-class="draft-modal mini_modal"
        >
          <div class="modal-content-wrapper floatCss">
            <h3>Withdraw request?</h3>
            <p>You may withdraw this request now. Withdrawal is immediate, and the original purchaser will be notified.</p>
            <h4>This cannot be reversed.</h4>
          </div>
          <div class="modal-content-bottom floatCss">
            <b-button
              class="pr-btn-3"
              @click="hideWithdrawModal"
            >
              Cancel
            </b-button>
            <b-button
              v-b-modal.modal-center2
              class="pr-btn-4"
              @click="withdrawTransferRequest"
            >
              Yes, withdraw
            </b-button>
          </div>
        </b-modal>
        <b-modal
          id="modal-center2"
          centered
          dialog-class="draft-modal mini_modal"
        >
          <div class="modal-content-wrapper floatCss">
            <div class="modal-icon-block floatCss">
              <img :src="successIcon">
            </div>
            <h3 style="margin: 0!important">
              The request has been withdrawn successfully.
            </h3>
          </div>
        </b-modal>
        <b-button
          class="nextStep-btn"
          :to="{ name: 'file-transfer-transferring-detail', params: { token: $route.params.token } }"
        >
          Next step
        </b-button>
        <b-modal
          id="modal-center3"
          centered
          dialog-class="draft-modal mini_modal"
        >
          <div class="modal-content-wrapper floatCss">
            <div class="modal-icon-block floatCss">
              <img :src="rejectIcon">
            </div>
            <h3>We were unable to process your request at the moment. Please try again.</h3>
          </div>
          <div class="modal-content-bottom floatCss">
            <b-row>
              <b-col cols="12">
                <b-button class="pr-btn-4">
                  Try again
                </b-button>
              </b-col>
            </b-row>
          </div>
        </b-modal>
      </div>
    </div>
  </div>
</template>

<script>
import {
  BRow, BCol, BCollapse, BButton, VBToggle,
} from 'bootstrap-vue'
import ToastificationContent from '@core/components/toastification/ToastificationContent.vue'
import AppLoader from '../AppLoader.vue'

export default {
  components: {
    BRow,
    BCol,
    BCollapse,
    BButton,
    AppLoader,
  },
  directives: {
    'b-toggle': VBToggle,
  },
  data() {
    return {
      // eslint-disable-next-line global-require
      agentPic: require('@/assets/images/file-transfer/agent-photo.png'),
      // eslint-disable-next-line global-require
      defaultUserAvatar: require('@/assets/images/avatars/default-user.png'),
      // eslint-disable-next-line global-require
      successIcon: require('@/assets/images/file-transfer/success-icon.svg'),
      // eslint-disable-next-line global-require
      rejectIcon: require('@/assets/images/file-transfer/reject-icon.svg'),
      showMessage: false,
      tokenDetail: {},
      transferRequest: {},
      fileDetail: {},
      lotDetail: {},
      mainAgent: {},
      packageName: '',
      titleText: 'Change of Purchaser',
      gstPercentage: 9,
    }
  },
  beforeMount() {
    const { token } = this.$route.params
    if (token) {
      this.$http.get('front-end/file-transfer/file-detail', { params: { token } })
        .then(response => {
          if (response.data.success) {
            if (response.data.validToken) {
              this.tokenDetail = response.data.token || {}
              this.transferRequest = response.data.transferRequest || {}
              this.fileDetail = response.data.fileDetail || {}
              const agents = this.fileDetail.agents || []
              const mainAgentData = agents.find(agent => agent.type === 'Sales & Service Agent' || agent.type === 'Service Agent')
              this.mainAgent = mainAgentData || {}
              this.lotDetail = this.transferRequest.relatedLot || {}
              if (this.transferRequest.transferType === 'ownership') {
                this.titleText = 'Transfer of ownership'
              }
              this.packageName = response.data.packageName
              this.showMessage = true
              this.gstPercentage = response.data.gstPercentage
            } else {
              this.$toast({
                component: ToastificationContent,
                props: {
                  title: 'Expired link',
                  icon: 'AlertTriangleIcon',
                  variant: 'danger',
                },
              })
            }
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          this.$toast({
            component: ToastificationContent,
            props: {
              title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
              icon: 'AlertTriangleIcon',
              variant: 'danger',
            },
          })
        })
    }
  },
  methods: {
    hideWithdrawModal() {
      this.$bvModal.hide('modal-center1')
    },
    withdrawTransferRequest() {
      const formData = new FormData()
      formData.append('transferRequest', this.transferRequest._id)
      this.$http.post('front-end/file-transfer/withdraw/submit', formData, {
        headers: { 'Content-Type': 'multipart/form-data' },
      })
        .then(response => {
          if (response.data.success) {
            this.$router.push({ name: 'file-transfer-landing', params: { token: this.$route.params.token } })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: response.data.message || '',
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
        .catch(error => {
          if (error.data.errors) {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.errors[0].msg || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          } else {
            this.$toast({
              component: ToastificationContent,
              props: {
                title: error.data.message || process.env.VUE_APP_DEFAULT_ERROR_MESSAGE,
                icon: 'AlertTriangleIcon',
                variant: 'danger',
              },
            })
          }
        })
    },
    getLotPrice() {
      const dspItems = this.lotDetail.dspItems || []
      let price = 0
      const lotPrice = dspItems.find(item => item.logicCode === 'MAINPRODUCT' && item.needType === this.fileDetail.needType)
      if (lotPrice) {
        price = +lotPrice.price
      }
      return price
    },
    getMaintenanceFee() {
      const dspItems = this.lotDetail.dspItems || []
      let price = 0
      const maintenanceFee = dspItems.find(item => item.logicCode === 'MAINTENANCE' && item.needType === this.fileDetail.needType)
      if (maintenanceFee) {
        price = +maintenanceFee.price
      }
      return price
    },
    getLotGstAmount() {
      const lotPrice = this.getLotPrice()
      const maintenanceFee = this.getMaintenanceFee()
      const total = lotPrice + maintenanceFee
      const gstAmount = (total * this.gstPercentage) / 100
      return gstAmount
    },
    getLotTotalValue() {
      const lotPrice = this.getLotPrice()
      const maintenanceFee = this.getMaintenanceFee()
      const gstAmount = this.getLotGstAmount()
      const total = lotPrice + maintenanceFee + gstAmount
      return total
    },
    getAgentData(agents, field) {
      const mainAgentData = agents.find(agent => agent.type === 'Sales & Service Agent' || agent.type === 'Service Agent')
      if (mainAgentData && mainAgentData[field]) return mainAgentData[field]

      if (field === 'image') return this.defaultUserAvatar
      return ''
    },
    getOrderTotal(fileDetail) {
      let total = 0
      const ledgerSummary = fileDetail.ledgerSummary || {}
      const totalDN = ledgerSummary.totalDN || 0
      const totalBilling = ledgerSummary.totalBilling || 0
      const totalCN = ledgerSummary.totalCN || 0

      total = (+totalDN + +totalBilling) - totalCN

      return `$${this.numberFormat(total)}`
    },
    getBillingItems(fileDetail) {
      const invoices = fileDetail.invoices || []
      const billingItems = []
      invoices.forEach(item => {
        item.billings.forEach(bill => {
          if (item.type === 'INVOICE') {
            billingItems.push({
              trxID: item.trxID,
              trxNo: item.trxNo,
              type: item.type,
              item: bill.item,
              amount: bill.amount,
              remarks: item.remarks,
              createdAt: item.createdAt,
              createdBy: item.createdBy,
            })
          }
        })
      })

      return billingItems
    },
    getRelatedFileItems(fileDetail) {
      const billingItems = this.getBillingItems(fileDetail)
      return billingItems.map(item => item.item).join(', ')
    },
    getDiscountTotal(fileDetail) {
      let total = 0
      const receipts = fileDetail.receipts || []
      receipts.forEach(item => {
        if (item.item.startsWith('DAL')) {
          total += +item.amount
        }
      })

      return total
    },
    getSubtotal(fileDetail) {
      const billingItems = this.getBillingItems(fileDetail)
      const total = billingItems.reduce((n, { amount }) => n + Number(amount), 0)
      const discountTotal = this.getDiscountTotal(fileDetail)
      return total - discountTotal
    },
    getGstAmount(fileDetail) {
      const invoices = fileDetail.invoices || []
      let gstAmount = 0
      invoices.forEach(item => {
        item.billings.forEach(bill => {
          if (bill.item.includes('GST')) {
            gstAmount += +bill.amount
          }
        })
      })

      let gstRebate = 0
      const receipts = fileDetail.receipts || []
      receipts.forEach(item => {
        if (item.item.toLowerCase().includes('gst rebate')) {
          gstRebate += +item.amount
        }
      })

      return gstAmount - gstRebate
    },
    getGstPercent(fileDetail) {
      const subtotal = this.getSubtotal(fileDetail)
      const gstAmount = this.getGstAmount(fileDetail)

      if (!subtotal || !gstAmount) {
        return 0
      }

      return Number(((gstAmount / subtotal) * 100).toFixed(2))
    },
    getCalculatedOrderTotal(fileDetail) {
      const subtotal = this.getSubtotal(fileDetail)
      const gstAmount = this.getGstAmount(fileDetail)

      return subtotal + gstAmount
    },
  },
}
</script>
